<template>
	<div class="posbox wid100"  :class="{'disamask': disabled}">

		<div class="head_btn" v-if="btnshow" :class="{'isdisabled': imgFileList.length >= 10}" title="最多上传10个文件">
			
				
			<el-upload
			ref="uploadsfile"
			 class="btn_upload FlexRow"
			 style="width: 100%;height: 100%;"
			list-type="picture-card"
			:accept="accept" :show-file-list="false"
			multiple action="#" :limit='10'
			:auto-upload="false"
			:on-change="imageChange"
			>
				上传文件
			</el-upload>
		</div>
		<div class="file_list" v-if="imgFileList.length"> 
			<div class="file_item" v-for="(item, index) in imgFileList" >
				<div class="img_box FlexRow" @click="onclickfile(item)">
					<!-- :preview-src-list="srcList" -->
					<el-image :src="item.imgSrc || item.url" lazy ></el-image>
				</div>
				
				<div class="file_info FlexColumn" @click="onclickfile(item)">
		
					<div class="file_name danhang">
						{{item.original_name || item.name || ''}}
					</div>
					<div class="file_bot danhang">
						<span>
							{{item.fileSize || ''}}
						</span>
						<span v-if="item.original_name" :title="item.member_name + '上传于' + item.create_time">
							{{item.member_name || '' }}
							上传于
							{{item.create_time || ''}}
						</span>
					</div>
				</div>
				<div class="pro_post">
					<div @click="onloafile(item)" v-if="item.original_name">
						<i class="el-icon-download"></i>
					</div>
					<div @click="delesucai(index)">
						<i class="el-icon-delete"></i>
					</div>
		
				</div>
			</div>
		</div>
		
		<!-- <nodata :show="imgFileList.length == 0"></nodata> -->
		
		
		
		<el-dialog
		  title="提示"
		  :visible.sync="qd_show"
		  width="300px"
		  :modal="false"
		  >
		  <span class="contpad">您确定删除吗？</span>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="qd_show = false">取 消</el-button>
		    <el-button class="comkl" @click="qd_comkl">确 定</el-button>
		  </span>
		</el-dialog>
		<!--  -->
		
		<el-dialog title="图片预览" :visible.sync="currentViewShow"
		append-to-body
		
		>
			<img width="100%" :src="currentViewImg" alt="">
		</el-dialog>
		
		


	</div>
</template>

<script>
	
	var that
	import {
		posterDownload
	} from "network/hk_poster"
	import {
		setupfile,
		getCurrentTime,
	} from 'network/hk_operset'
	import Dialog from "components/content/dialog/Dialog";
	import nodata from "@/components/content/publics/nodata.vue";
	export default {
		components: {
			Dialog,
			nodata,
		},
		
		name: "enclofile",
		props: {
			// 
			enclist: {
				type: Array,
				default:  ()=>{
					return []
				},
			},
			fieldid: {
				type: Number,
				default: 0,
			},
			btnshow:{
				type: Boolean,
				default: true,
			},
			disabled:{
				type: Boolean,
				default: false,
			},
			
			accept: {
				type: String,
				default: '.docx,.doc,.xlsx,.xls,.pptx,.ppt,.pdf,.png,.jpg,.jpeg',  // file image
				// default: '.png,.jpg,.jpeg',  // file image
			},
			
			filenum: {
				type: Number,
				default: 20,
			},
			filesize: {
				type: Number,
				default: 20,
			},
			count: { 
				type: Number,
				default: 1,
			},
			
			
		},
		data() {
			return {
				flielen: 0,
				fileuplen: 0,
				
				urlhead: 'https://scrm.51kuaiding.com/scrm/hktxcx/customer',
				
				newArr: [],
				
				qd_show: false,
				qd_dialog: {
					name: '提示',
					width: '300px'
				},
				currentDel: '',
				
				imgFileList: [],
				currentViewImg: '',
				currentViewShow: false,
				
				srcList: [],
				
				upSavelist: [],
			}
		},
		watch: {
			enclist(){
				this.setdatas()
			},
			imgFileList(){
				let imgarr = []
				for(let item of this.imgFileList) {
					let url = item.url || item.image
					if(url) {
						imgarr.push(url)
					}
				}
				this.srcList = imgarr
			},
		},
		created() {
			that = this
			// 
			this.setdatas()
		},
		methods: {
			setdatas(){
				this.imgFileList = JSON.parse(JSON.stringify(this.enclist))
			},
			onclickfile(item){
				if(item.isImg) {
					let {url} = item
					this.currentViewImg = url
					this.currentViewShow = true
				}
				else if(item.file_type == 0 && item.imgSrc) {
					let url = item.imgSrc
					this.currentViewImg = url
					this.currentViewShow = true
				}
			},
			onloafile(item){
				let time = 120
				let timer = null
				
				let fileurl = '';
				if(item.file_type == 0) {
					fileurl = item.imgSrc
				}
				else {
					fileurl = item.path
				}
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				timer = setInterval(()=>{
					time -= 1
					if(time == 0) {
						this.$alertMess('请求超时','error')
						loading.close();
					}
				}, 1000)
				let img_name = fileurl.replace(/^(.*\/)/, '') || '';
				// let img_name = item.original_name || '';
				posterDownload(fileurl).then(res => {
					var src = 'data:image/jpg;base64,' + btoa(new Uint8Array(res).reduce((data, byte) => data +
						String.fromCharCode(byte), ''));
				
					var link = document.createElement('a');
					
					link.href = src;
					link.download = img_name;
					link.click();
					loading.close();
					clearInterval(timer)
				
				}).catch(error => {
					this.$message({
						message: "下载失败",
						type: 'error',
						offset: 100
					});
					loading.close();
					clearInterval(timer)
				})
				
				
			},
			
			delesucai(index) {
				
				// this.qd_show = true
				this.currentDel = index
				this.imgFileList.splice(index, 1)
			},
			qd_comkl(){
				this.qd_show = false
				
				// let data = {
				// 	index: this.currentDel,
				// }
				
				// if(this.fieldid) {
				// 	data.id = this.fieldid
				// }
				// this.$emit('fndelet', data)
			},
			
			// 选择文件 显示临时图片，名称
			imageChange(file, fileList) {
				let maxlen = 10
				let maxSix = 10
				let len = this.imgFileList.length
				if (len < maxlen) {
					
					this.fileuplen = 0
					if (file.size / 1024 / 1024 > maxSix) {
						this.fn_clearFiles()
						this.flielen = 0
						this.fileuplen = 0
						this.$alertMess(`上传附件大小不能超过${maxSix}MB！`, 'error')
					}
					else {
						let res = this.temporaryfile(file.raw)
						if(res != 'image') {
							file.url = res
						}
						else {
							file.isImg = true
							
						}
						file.fileSize = this.bytesToSize(file.size)
						this.flielen+=1
						console.log(file,'file')
						this.imgFileList.push(file)
					}
				} else {
					this.fn_clearFiles()
					this.flielen = 0
					this.fileuplen = 0
					this.$alertMess(`最多上传${maxlen}个附件、素材`, 'error')
				}
			},
			// 判断素材类型
			temporaryfile(raw){
				let typeStr = raw.type.slice(0,5)
				if(typeStr == "image") {
					return 'image'
				}
				else if(typeStr == "video") {
					return `${this.urlhead}/mat1-1.png`
				}
				else {
					let fileName = raw.name
					for (let i = 0; i < fileName.length; i++) {
						if (fileName[i] == ".") {
							let fileType = fileName.slice(i + 1);
							if (fileType == "docx" || fileType == "doc") {
								return `${this.urlhead}/mat1-2.png`
							} else if (fileType == "xlsx" || fileType == "xls") {
								return `${this.urlhead}/mat1-4.png`
							} else if (fileType == "pptx" || fileType == "ppt") {
								return `${this.urlhead}/mat1-3.png`
							} else if (fileType == "pdf") {
								return `${this.urlhead}/mat1-5.png`
							}
						}
					}
				}
			},
			// 上传附件 danhang
			flieChange() {
				this.upSavelist = this.imgFileList.filter(v=>v.original_name)
				let arr1 = this.imgFileList.filter(v=>v.original_name == undefined)
				// flielen  fileuplen
				if(arr1.length) {
					for(let item of arr1) {
						if(item.original_name == undefined) {
							this.fn_setupfile(item)
						}
					}
				}
				else {
					let data = {
						list: this.upSavelist,
					}
					if(this.fieldid) {
						data.id = this.fieldid
					}
					this.$emit('setupfile', data)
					this.upSavelist = []
					this.fn_clearFiles()
					this.imgFileList = []
				}
				
			},
			
			fn_clearFiles() {
				
				if (this.$refs.uploadsfile) {
					this.$refs.uploadsfile.clearFiles()
				}
			},


			fn_setupfile(file) {
				// const loading = this.$loading({
				// 	lock: true,
				// 	text: 'Loading',
				// 	spinner: 'el-icon-loading',
				// 	background: 'rgba(0, 0, 0, 0.7)'
				// });
				let fd = new FormData()
				fd.append('store_id',localStorage.store_id)
				fd.append('file_name', file.name)
				fd.append('file[]', file.raw)
				
				
				setupfile(fd).then(res => {
					let obj = res.result[0] // 返回的文件信息
					// 
					if (this.$handlereq(res)) {
						
						let ele = {
							original_name: obj.original_name, //文件名
							path: obj.file_url || "", // 文件地址
							fileSize: this.bytesToSize(file.size),
							member_name: localStorage.member_name,
							create_time: getCurrentTime(true),
							file_type: obj.file_type,
						}
						if (obj.file_type == 0) {
							ele.imgSrc = obj.file_url // 文件图标
						} 
						else {
							ele.imgSrc = that.getFileType_(obj) // 文件图标
						}
						this.upSavelist.push(ele)
						// 
						
						this.fileuplen += 1
						if(this.fileuplen == this.flielen) {
							
							this.fileuplen = 0
							this.flielen = 0
							
							this.fn_clearFiles()
							
							let data = {
								list: this.upSavelist,
							}
							if(this.fieldid) {
								data.id = this.fieldid
							}
							this.$emit('setupfile', data)
							this.upSavelist = []
							this.fn_clearFiles()
							this.imgFileList = []
							
						}

					}
					// loading.close();

				})
			},


			bytesToSize(bytes) {
				if (bytes === 0) {
					return "0 B";
				}
				let k = 1024;
				let sizes = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
				let i = Math.floor(Math.log(bytes) / Math.log(k));
				let num = bytes / Math.pow(k, i);
				return num.toPrecision(3) + " " + sizes[i];
			},
			// 文件图标，文件类型
			getFileType_(obj) {
				let str = obj.original_name;
				if (obj.file_type != 0) {
					for (let i = 0; i < str.length; i++) {
						if (str[i] == ".") {
							let fileType = str.slice(i + 1);
							if (fileType == "docx" || fileType == "doc") {
								return `${this.urlhead}/mat1-2.png`
							} else if (fileType == "xlsx" || fileType == "xls") {
								return `${this.urlhead}/mat1-4.png`
							} else if (fileType == "pptx" || fileType == "ppt") {
								return `${this.urlhead}/mat1-3.png`
							} else if (fileType == "pdf") {
								return `${this.urlhead}/mat1-5.png`
							}
						}
					}
				}
			
			},
			
			


		}
	}
</script>

<style scoped lang="scss">
	/deep/ .el-upload--picture-card{
		// width: 85px;
		// height: 32px;
		border-radius: 2px;
		border:none;
		font-size: 14px;
		background: none;
	}
	.posbox{
		position: relative;
		// min-width: 200px;
		padding-bottom: 50px
	}
	.posbox.disamask::after{
		top: 0;
		left:0;
		content: '';
		display:block;
		position: absolute;
		z-index: 100;
		width: 100%;
		height: 100%;
		cursor: not-allowed;
	}
	.contpad{
		padding: 20px;
		display:block;
	}
	
	.comkl{
		background-color: #2a75ea !important;
		color:#fff !important;
	}
	
	.file_name {
		max-width: 220px;
		font-size: 14px;
		font-weight: 400;
		color: rgba(56, 56, 56, 1);
	}
	
	.file_bot {
		max-width: 190px;
		font-size: 12px;
		color: rgba(166, 166, 166, 1);
	}
	
	.pro_post {
		position: absolute;
		bottom: 18px;
		right: 20px;
		display: flex;
		align-items: center;
	
		div {
			margin-left: 8px;
	
			i {
				cursor: pointer;
				color: rgba(145, 148, 154, 1);
			}
			i:hover{
				color:#2a75ea;
			}
		}
		
	}
	
	/deep/ .head_btn .el-upload{
		color:#fff !important;
	}
	.head_btn {
		width: 85px;
		height: 32px;
		border-radius: 2px;
		font-size: 14px;
		font-weight: 500;
		color: rgba(255, 255, 255, 1);
		display: flex;
		align-items: center;
		justify-content: center;
		background: rgba(42, 117, 234, 1);
		margin-right: 5px;
		cursor: pointer;
		margin-bottom: 20px;
		.btn_upload {
			width: 100%;
			height: 100%;
			font-size: 14px;
			font-weight: 500;
			color: rgba(255, 255, 255, 1);
	
		}
	}
	
	.file_list {
		width: 500px;
		display: flex;
		flex-wrap: wrap;
		
	
		.file_item {
			cursor: pointer;
			text-decoration: none;
			margin-right: 20px;
			margin-bottom: 20px;
			padding: 5px;
			width: 332px;
			height: 59px;
			border-radius: 5px;
			background: rgba(244, 245, 249, 1);
			display: flex;
			align-items: center;
			position: relative;
	
			.pro_post {
				bottom: 6px;
				right: 15px;
	
				div {
					margin-left: 15px;
				}
			}
	
		}
	
		.file_item .img_box {
			width: 50.47px;
			height: 50.47px;
			border-radius: 5px;
			overflow: hidden;
	
		}
	
		.file_item .img_box img {
			width: 100%;
			height: 100%;
			display: block;
		}
	
		.file_item .file_info {
			text-decoration: none;
			flex: 1;
			height: 100%;
			justify-content: space-between;
			padding-left: 11px;
			align-items: flex-start;
		}
	}
	
	
</style>
